import { DeleteTextNoteAction, EntityDiagramActionFn } from '../types';

export const deleteTextNoteAction: EntityDiagramActionFn<
  DeleteTextNoteAction
> = (state, action) => {
  return {
    ...state,
    nodes: state.nodes.filter((n) => n.id !== action.nodeId),
  };
};
